import { getApiUrl } from '@/api/config'

/**
 * Authed fetch for a task artifact emitted by gravitutor
 * (`GET /api/gravitutor/tasks/{taskId}/files/{filename}`).
 *
 * Ported from S&D's inline `fetch(`${getAPIURL()}gravi/tasks/...`)` calls in
 * `InlineImage` / `InlineChart` / `AttachmentChip`, adapted to Crossroads
 * conventions: the `getApiUrl()` base + the `accessToken` localStorage key used
 * by `@/api/typedClient`.
 *
 * NOTE(v1): artifact download is deferred on the backend (see plan Task 0.3) —
 * `GET /tasks/{id}/files/{name}` may return 404/501 until wired. These helpers
 * are ported faithfully so the UI lights up the moment the route is enabled.
 */

const artifactUrl = (taskId: string, filename: string): string =>
  getApiUrl(`gravitutor/tasks/${taskId}/files/${encodeURIComponent(filename)}`)

export function fetchArtifact(
  taskId: string,
  filename: string,
  signal?: AbortSignal,
): Promise<Response> {
  const token = localStorage.getItem('accessToken')
  return fetch(artifactUrl(taskId, filename), {
    signal,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })
}
